<div class="policy-container" dir="ltr">
  <h3>Privacy <span> Policy </span></h3>
  <p class="text-start">
    <b>Effective Date: 6/5/2024</b>
    <br /><br />
    <b>Up Career</b> is committed to protecting your privacy. This Privacy
    Policy explains how we collect, use, disclose, and safeguard your
    information when you visit our website https://upcareeraicv.com, use our
    services, or engage with us in other ways. Please read this policy carefully
    to understand our views and practices regarding your personal data and how
    we will treat it. <br /><br />
    <b>1. Information We Collect</b>
    <br />
    We may collect and process the following types of information:
    <br /><br />
    a. Personal Information:
    <br />
    Name <br />
    Email address <br />
    Phone number <br />
    Address <br />
    Job title <br />
    Company name
    <br /><br />
    b. Usage Information:
    <br />
    Information about your visit, including the full Uniform Resource Locators
    (URL), clickstream to, through, and from our site (including date and time),
    products/services you viewed or searched for, page response times, download
    errors, length of visits to certain pages, page interaction information
    (such as scrolling, clicks, and mouse-overs), and methods used to browse
    away from the page.
    <br /><br />
    c. Marketing and Communications Data:
    <br />
    Your preferences in receiving marketing from us and your communication
    preferences.
    <br /><br />
    <b>2. How We Use Your Information</b>
    <br />
    We use the information we collect in the following ways:
    <br /><br />
    a. To Provide and Improve Our Services:
    <br />
    To deliver our services, including IT consulting, digital marketing, web and
    app development, social media management, and advertising. To process your
    requests and orders.
    <br /><br />
    b. For Marketing and Communications:
    <br />
    To send you promotional materials and updates about our services. To
    communicate with you about changes to our services, policies, and other
    administrative information.
    <br /><br />
    c. For Analytics and Personalization:
    <br />
    To understand how you use our website and services and to personalize your
    experience. To measure the effectiveness of our advertising.
    <br /><br />
    d. For Security and Compliance:
    <br />
    To protect our website, employees, and business operations. To comply with
    legal obligations, resolve disputes, and enforce our agreements.
    <br /><br />
    <b>3. Sharing Your Information</b>
    <br />
    We do not sell, trade, or otherwise transfer your personal information to
    outside parties except as described below:
    <br /><br />
    a. Service Providers:
    <br />
    We may share your information with third-party service providers who perform
    services on our behalf, such as payment processing, data analysis, email
    delivery, hosting services, customer service, and marketing assistance.
    <br /><br />
    b. Legal Requirements:
    <br />
    We may disclose your information if required to do so by law or in response
    to valid requests by public authorities (e.g., a court or a government
    agency).
    <br /><br />
    c. Business Transfers:
    <br />
    In the event of a merger, acquisition, or asset sale, your information may
    be transferred. We will provide notice before your personal information is
    transferred and becomes subject to a different privacy policy.
    <br /><br />
    <b>4. Your Choices</b>
    <br />
    You have the following rights regarding your personal data:
    <br /><br />
    a. Access and Update:
    <br />
    You can access and update your personal information by contacting us at
    [Insert Contact Information].
    <br /><br />
    b. Opt-out:
    <br />
    You can opt-out of receiving marketing communications from us by following
    the unsubscribe instructions included in our emails or by contacting us
    directly.
    <br /><br />
    c. Data Deletion:
    <br />
    You can request the deletion of your personal information by contacting us
    at [Insert Contact Information]. Please note that we may retain certain
    information as required by law or for legitimate business purposes.
    <br /><br />
    <b>5. Security</b>
    <br />
    We implement appropriate technical and organizational measures to protect
    your personal information against unauthorized access, alteration,
    disclosure, or destruction.
    <br /><br />
    <b>6. Changes to This Privacy Policy</b>
    <br />
    We may update this Privacy Policy from time to time. We will notify you of
    any changes by posting the new Privacy Policy on our website. You are
    advised to review this Privacy Policy periodically for any changes.
    <br /><br />
    <b>7. Contact Us</b>
    <br />
    If you have any questions about this Privacy Policy, please contact us at:
    <br /><br />
    Up Career
    <br />
    Email:
    <a href="info@upcareeraicv.com">info@upcareeraicv.com</a>
    <br />
    Phone: <a href="tel:01508305515">01508305515</a>
  </p>
</div>
